import _ from "lodash";
import {REVIEWBUILDER_CONTENT_PROVIDERS} from "./ReviewsTabData";
import reviewFiltersStore, { dateRanges, reports } from "../../modules/reviews/ReviewFilterStore";
import { variableWaitDebounce } from "./ReviewController";
import {bindShallow} from "../../uiMigration/bindAngularWithMobx";
import SelectedLocationsStore from "../../services/locations/SelectedLocationsStore";
import ProvidersStore from "../../services/providers/ProvidersStore";
import {toJS} from "mobx";
import { bindReviewFiltersAndSelectedLocationToAngular } from "./filterBindingUtils";
import highcharts from "highcharts";

let moment = require('moment');

angular.module('clientDashboardApp').controller("ReviewSummaryCtrl", function (
  $scope, $log, $timeout, $location, userService, reviewService, listingService, locationService, configService, reactContainer
) {
    $scope.firstSummaryRender = true;
    $scope.providers = ProvidersStore.reviewProviders;

    configService.getBrandConfig(false, false).then(function (brandConfig) {
      $scope.brandConfig = brandConfig;
    });

    $scope.orderUndefined = function (rowData) {
      var columnData = rowData[$scope.providerSummaryOptions.sortField];
      if (!angular.isDefined(columnData)) {
        return Number.MIN_VALUE;
      }
      return columnData;
    };

    $scope.hideYelpStuff = false;
    $scope.assetUrl = window.assetUrl

    $scope.providerSummaryOptions = {sortField: 'count', reverseSortOrder: true};
    $scope.providerSummarySortIcon = function (column) {
      if ($scope.providerSummaryOptions.sortField === column) {
        if ($scope.providerSummaryOptions.reverseSortOrder) {
          return 'fa-sort-down';
        } else {
          return 'fa-sort-up';
        }
      } else {
        return 'fa-sort';
      }
    };

    $scope.sortProviderSummaryTable = function (sortColumn) {
      if ($scope.providerSummaryOptions.sortField === sortColumn) {
        $scope.providerSummaryOptions.reverseSortOrder = !$scope.providerSummaryOptions.reverseSortOrder;
      } else {
        $scope.providerSummaryOptions.sortField = sortColumn;
        $scope.providerSummaryOptions.reverseSortOrder = false;
      }
    };

    $scope.getBBBRatingImage = rating => {
      if(rating){
        let parts = rating.split(" ");
        let url;
        if(parts.length > 1){
          // Accredited businesses will be "A+ Accredited", non will be "A+"
          parts.forEach((item, index) => parts[index] = encodeURIComponent(parts[index]));
          url = parts.reverse().join('-');
        }else{
          url = encodeURIComponent(rating);
        }
        const fixedUrl = url.replace("Some(", "").replace(")", "")
        return `/images/bbb/lg-${fixedUrl}.png`;
      }
    }

    $scope.getRangeName = (range) => {
      if($scope.searchConfig.range === "SpecificDates"){
        return `${moment($scope.searchConfig.startDate).format("M/D/YY")} - ${moment($scope.searchConfig.endDate).format("M/D/YY")}`;
      }

      const found = dateRanges.find(r => r.id === range)
      return found ? found.name : "";
    }

    $scope.$on('$locationChangeSuccess',function(event, current) {
      drawBBB();
    });
    //hoisted method, defined below
    drawBBB();

    /** This function updates state to loading, and fetches results from current filters immediately */
    function loadContent() {
      const filter = {};
      filter.groupId = $scope.searchConfig.groupId;
      filter.offset = 0;

      if ($scope.searchConfig.range) filter.range = $scope.searchConfig.range;

      if ($scope.searchConfig.providers) filter.providers = $scope.searchConfig.providers.join();

      if(reviewFiltersStore.state.ratings.length) filter.ratings = reviewFiltersStore.state.ratings.join(",");

      const selected = dateRanges.find(range =>
        range.to.diff(reviewFiltersStore.state.endDate, "days") === 0 &&
        range.from.diff(reviewFiltersStore.state.startDate, "days") === 0
      );

      filter.reportRange = !!selected && selected.id !== "LastDay" ? selected.id : "SpecificDates";

      if (reviewFiltersStore.state.startDate && filter.reportRange !== "AllTime") {
        filter.startDate = moment($scope.searchConfig.startDate).format("YYYY-MM-DD");
      }


      if (reviewFiltersStore.state.endDate && filter.reportRange !== "AllTime") {
        filter.endDate = moment($scope.searchConfig.endDate).format("YYYY-MM-DD");
      } else if (!reviewFiltersStore.state.endDate) {
        const defaultDateRange = dateRanges.find(x => x.id === 'Last3Months');
        filter.endDate = defaultDateRange.to.format("YYYY-MM-DD");
      }

      $scope.reportType = $scope.searchConfig.report;

      reviewService.generateReviewReport({...filter, summaryType: "PerPeriod"})
        .then( x => {
          const {dateRange, reviewsByPeriod} = x;
          updateSearchResults(() => $scope.loadingPerPeriod = false, {dateRange, reviewsByPeriod})
        });

      reviewService.generateReviewReport({...filter, summaryType: "OverallSummary"})
        .then( x => {
          const {
            competitorsPeriodSummary,
            competitorsTotalSummary,
            dateRange,
            individualCompetitors,
            periodSummary,
            totalSummary
          } = x;
          updateSearchResults(() => $scope.loadingOverallSummary = false, {
            competitorsPeriodSummary,
            competitorsTotalSummary,
            dateRange,
            individualCompetitors,
            periodSummary,
            totalSummary
          })
        });

      reviewService.generateReviewReport({...filter, summaryType: "PerProvider"})
        .then( x => {
          const {dateRange, providerReport, competitorsProviderReport} = x;
          updateSearchResults(() => $scope.loadingPerProvider = false, {dateRange, providerReport, competitorsProviderReport})
        });

      populateNetPromoterScore();
    }

    // set this to a time in the future to prevent search from being queried for a bit (e.g. if the user
    // is trying to select options in a menu
    let searchBackoff = moment().subtract(1, "hour");
    // if searchBackoff is set, a specific debounce time can be scheduled, otherwise use the min
    function extendableWait() {
      const min = 500;
      const remaining = searchBackoff.diff(moment(), "ms");
      return Math.max(min, remaining);
    }

    /**
     * This is the primary function that should be called to update search results if the input is from the UI
     * e.g. from changing filters. It schedules the review search to be executed in the future (usually 250ms).
     * Repeat calls will extend the execution.
     * */
    function executeSearch() {
      const executingSearch = $scope.loadingPerPeriod ||
        $scope.loadingOverallSummary ||
        $scope.loadingPerProvider;

      if (!executingSearch) {
        $scope.loadingPerPeriod = true;
        $scope.loadingOverallSummary = true;
        $scope.loadingPerProvider = true;
        $scope.loadingNPS = true;
        loadContentDebounced()
      }
    }
    const loadContentDebounced = variableWaitDebounce(loadContent, extendableWait);

    $scope.$watch("searchConfig", function (newConfig,oldConfig) {

      if (!!newConfig && !angular.equals(newConfig.report, !!oldConfig ? oldConfig.report : {}) || !angular.equals(newConfig, oldConfig)) {
        if (!!newConfig.report && newConfig.report.reportType === 'reviewSummary') {
          executeSearch();
        }
      }

    }, true);

    function initializeReport() {
      $scope.searchConfig = {
        report: reports.find(x => x.reportType === 'reviewSummary'),
        doNotUseSummaries: false
      };

      $scope.initialSummaryLoad = true;
      bindReviewFiltersAndSelectedLocationToAngular($scope, $scope.searchConfig);
      executeSearch();
    }

    function populateNetPromoterScore () {

      const providers = $scope.searchConfig.providers || [];
      if (providers.find(x => REVIEWBUILDER_CONTENT_PROVIDERS.includes(x)) !== undefined) {

        let reviewBuilderAlias = "Review Builder"
        if ($scope.searchConfig.providers.includes("SHAREITFORWARD")) {
          reviewBuilderAlias = "Share It Forward"
        } else if ($scope.searchConfig.providers.includes("RESIDENTCAPTURE")) {
          reviewBuilderAlias = "Resident Capture"
        } else if ($scope.searchConfig.providers.includes("PATIENTREVIEWS")) {
          reviewBuilderAlias = "Patient Reviews"
        } else if ($scope.searchConfig.providers.includes("KELLEYBLUEBOOK")) {
            reviewBuilderAlias = "Kelley Blue Book"
        }

        $scope.npsDescription = `*Based on ${reviewBuilderAlias} respondents`

        const selected = dateRanges.find(range =>
          range.to.diff(reviewFiltersStore.state.endDate, "days") === 0 &&
          range.from.diff(reviewFiltersStore.state.startDate, "days") === 0
        );
        
        const startDate = moment($scope.searchConfig.startDate).format("YYYY-MM-DD");
        const endDate = moment($scope.searchConfig.endDate).format("YYYY-MM-DD");

        const selectedOrSpecificDates = selected || {
          from: startDate,
          to: endDate,
          name: "Selected Dates",
          id: "SpecificDates",
          dateRangeType: "selected"
        };

        const isAllTime = selectedOrSpecificDates.id === "AllTime";
        const isSelected = selectedOrSpecificDates.id === "SpecificDates" || selectedOrSpecificDates.id === "LastDay";

        const transformedConfig = {
          ...$scope.searchConfig,
          groupId: SelectedLocationsStore.legacyGroupIdOrAll,
          reportRange: !isSelected ? selectedOrSpecificDates.id : "SpecificDates",
          range: undefined,
          startDate: isAllTime || !isSelected ? undefined : startDate,
          endDate: isAllTime || !isSelected ? undefined : endDate
        };

        reviewService
        .getNetPromoterScore(transformedConfig)
        .then(response => {
          $scope.loadingNPS = false;
          $scope.netPromoterScore = response.netPromoterScore;
        })
      } else {
        $scope.netPromoterScore = undefined
      }
    }

    function updateSearchResults(applyLoaded, searchResponse) {
      applyLoaded();
      $scope.searchResults = {
        ...$scope.searchResults,
        ...searchResponse
      };
    }

    function drawBBB(){
      $scope.bbbRating = undefined;
      const maybeLocationId = locationService.getSelectedGroupId()
      if (maybeLocationId.includes("legacy-")) {
        // If we have a single location selected
        listingService.getListing({locationId: maybeLocationId.replace("legacy-", ""), providers: "BBB"})
          .then(resp => resp.data.listings)
          .then(listings => {
            if (listings.length === 1) {
              $scope.bbbRating = listings[0]["bbbRating"]
            }
          })
      }
    }

    function generateProviderReports() {
      var providerReports = [];
      angular.forEach(!!$scope.searchResults ? $scope.searchResults.providerReport : [], function (report, provider) {
        report['provider'] = provider;
        let competitorData = $scope.searchResults.competitorsProviderReport[provider];

        report['countWithoutRecommendations'] = provider === "FACEBOOK" ? report.count-report.totalRecommended-report.totalNotRecommended : report.count;

        report['competitorCount'] = !!competitorData && competitorData.count || 0;

        if (competitorData && competitorData.avgRating && competitorData.count > 0) {
          report['competitorRating'] = competitorData.avgRating;
        }
        if (competitorData && angular.isDefined(competitorData.totalRecommended) && angular.isDefined(competitorData.totalNotRecommended)) {
          report['competitorRecommended'] = competitorData.totalRecommended
          report['competitorNotRecommended'] = competitorData.totalNotRecommended
        }

        report['competitorCountWithoutRecommendations'] = competitorData && (provider === "FACEBOOK" ?
          competitorData.count-(competitorData.totalRecommended || 0)-(competitorData.totalNotRecommended || 0) : competitorData.count
        ) || 0;

        providerReports.push(report);
      });

      userService.currentUser().then(function (resp) {
        if (resp.userId == "56f09dcc8b346016e8fd4fcd") { //POPREMAX PROVIDER HACK FOR DEMO
          console.log("popremax");
          _.each($scope.searchResults.providerReport, function (item) {
            item.provider = reviewService.replaceContentProvider(item.provider, "id");
          });
        }
        if (resp.userId == "57eea55f66d4e052c8f6b0f0") {
          $scope.hideYelpStuff = true
        }
      });

      $scope.providerReports = providerReports;
    }

    $scope.renderedOverTimeOnce = false;
    function drawHighCharts(old, reportSummary) {
      //Wrap in timeout since we want it to load after the scope is updated.
      if (!!reportSummary && !!reportSummary.reviewsByPeriod && (!$scope.renderedOverTimeOnce || !_.isEqual((!!old ? old.reviewsByPeriod : {}), reportSummary.reviewsByPeriod))) {
        $scope.renderedOverTimeOnce = true;
        $timeout(function () {

          var numberOfReviews = [];
          var avgRatings = [];
          const reviewsByPeriod = reportSummary.reviewsByPeriod;

          //Order the months in ascending order
          var orderedMonths = Object.keys(reviewsByPeriod.values).sort();
          angular.forEach(orderedMonths, function (date) {
            if (!date) {
              return;
            }
            var monthlySummary = reviewsByPeriod.values[date];
            var d = new Date(date);
            numberOfReviews.push([d.getTime(), monthlySummary.total]);
            if (angular.isDefined(monthlySummary.avgRating)) {
              avgRatings.push([d.getTime(), Math.round(monthlySummary.avgRating * 100) / 100]);
            }
          });

          var chart_div = document.querySelector('#reviews_by_month_chart');

          var reviewChartConfig = {
            chart: {
              zoomType: 'xy',
              alignTicks: false
            },
            title: {
              text: null
            },
            xAxis: {
              type: 'datetime',
              title: {
                text: 'Date'
              },
              ordinal: false,
              minTickInterval: 24 * 3600 * 1000 //Limit ticks to a minimum of 1 day
            },
            yAxis: [
              { // Primary yAxis
                title: {
                  text: 'Number of Reviews'
                }
              },
              { // Secondary yAxis
                title: {
                  text: 'Average Rating'
                },
                opposite: true,
                min: 0,
                max: 5,
                tickPositions: [0, 1, 2, 3, 4, 5],
                gridLineWidth: 0
              }
            ],
            tooltip: {
              shared: false
            },
            legend: {
              layout: 'horizontal',
              align: 'center',
              verticalAlign: 'top',
              borderWidth: 0
            },
            series: [
              {
                name: 'Total Reviews',
                type: 'column',
                data: numberOfReviews
              },
              {
                name: 'Average Rating',
                type: 'spline',
                yAxis: 1,
                data: avgRatings,
                marker: {
                  enabled: false
                }
              }
            ],
            credits: {
              enabled: false
            }
          };

          if (reportSummary.dateRange) {
            var startDate = new Date(reportSummary.dateRange.startDate);
            var endDate = new Date(reportSummary.dateRange.endDate);
            reviewChartConfig.xAxis.min = startDate.getTime();
            //The report range is exclusive the max value
            if (reviewsByPeriod.period === 'Day') {
              //Last ticket at end of previous day
              endDate.setHours(-1);
            } else if (reviewsByPeriod.period === 'Month') {
              //Last tick on previous day
              endDate.setDate(0);
            }
            reviewChartConfig.xAxis.max = endDate.getTime();
            if (reportSummary.dateRange.startDate === reportSummary.dateRange.endDate) {
              reviewChartConfig.xAxis.max = endDate.getTime() + 1000 * 60 * 60 * 24 // +1 day
            }
          }

          highcharts.chart(chart_div, reviewChartConfig);
        })
      }
    }

    $scope.renderedSentimentOnce = false;
    function drawSentimentChart(old, reportSummary) {
      //Wrap in timeout since we want it to load after the scope is updated.
      if (!!reportSummary && !!reportSummary.periodSummary && (!$scope.renderedSentimentOnce || !_.isEqual((!!old ? old.periodSummary : {}), reportSummary.periodSummary))) {
        $scope.renderedSentimentOnce = true;
        $timeout(function () {
            
          highcharts.chart(document.querySelector('#reviews_sentiment_chart'), {
            chart: {
              plotBackgroundColor: null,
              plotBorderWidth: 0,
              plotShadow: false
            },
            title: {
              text: null
            },
            legend: {
              layout: 'horizontal',
              align: 'center',
              verticalAlign: 'top',
              borderWidth: 0
            },
            tooltip: {
              pointFormatter: function () {
                return this.y.toLocaleString() + " reviews";
              }
            },
            plotOptions: {
              pie: {
                dataLabels: {
                  enabled: true,
                  format: '{point.percentage:.1f} %',
                  style: {
                    color: (Highcharts.theme && Highcharts.theme.contrastTextColor) || 'black'
                  },
                  distance: 10
                },
                showInLegend: true
              }
            },
            series: [
              {
                type: 'pie',
                name: 'Review Sentiment',
                innerSize: '40%',
                data: [
                  {
                    name: 'Negative',
                    color: 'var(--danger)',
                    y: (reportSummary.periodSummary.countByRating['1star'] || 0) + (reportSummary.periodSummary.countByRating['2star'] || 0) + reportSummary.periodSummary.totalNotRecommended
                  },
                  {
                    name: 'Positive',
                    color: 'var(--success)',
                    y: (reportSummary.periodSummary.countByRating['4star'] || 0) + (reportSummary.periodSummary.countByRating['5star'] || 0) + reportSummary.periodSummary.totalRecommended
                  }
                  ,
                  {
                    name: 'Neutral',
                    color: 'var(--warning)',
                    y: reportSummary.periodSummary.countByRating['3star'] || 0
                  }
                ],
                point: {
                  events: {
                    click: function (event) {
                      const eventName = this.name;
                      $scope.$apply(function () {
                        switch (eventName) {
                          case 'Negative':
                            reportSummary.ratings = ["1star", "2star", "notRecommended"];
                            break;
                          case 'Neutral':
                            reportSummary.ratings = ["3star"];
                            break;
                          case 'Positive':
                            reportSummary.ratings = ["4star", "5star", "recommended"];
                        }
                      })
                    }
                  }
                }
              }
            ],
            credits: {
              enabled: false
            }
          });

        })
      }
    }

    $scope.prepCompetitors = function () {
      if (!!$scope.searchResults) {
        $scope.competitor = {};
        $scope.competitors = [];
        if (!$scope.loadingOverallSummary && $scope.searchResults.individualCompetitors.length > 0) {
          $scope.competitors = angular.copy($scope.searchResults.individualCompetitors);
          $scope.competitor.hasIndividualCompetitors = true;
        }
        if ($scope.searchResults.competitorsTotalSummary && $scope.searchResults.competitorsPeriodSummary) {
          const compAverage = {
            locationNameAddress: 'Local Competitor Average',
            competitorsTotalSummary: $scope.searchResults.competitorsTotalSummary,
            competitorsPeriodSummary: $scope.searchResults.competitorsPeriodSummary
          };
          $scope.competitors.unshift(compAverage);
          $scope.competitor.selectedCompetitor = compAverage;
        }
      }
    };

    $scope.$watch("searchResults", function (newVal, old) {
      if (!_.isEqual(old, newVal)) {
        $scope.prepCompetitors();

        !!newVal && drawHighCharts(old, newVal);
        !!newVal && drawSentimentChart(old, newVal);
        generateProviderReports();

      }
      $scope.firstSummaryRender = false;
    })

    $scope.prepCompetitors();
    !!$scope.searchResults && drawHighCharts({}, $scope.searchResults);
    !!$scope.searchResults && drawSentimentChart({}, $scope.searchResults);
    generateProviderReports();


    initializeReport();

});
